import React from 'react';
import Layout from '../layouts/six';
import Tournament from './partials/tournament';
import moment from 'moment';
import _ from 'lodash';
import { Animated } from "react-animated-css";
import { Link } from 'react-router';
import { preload } from '../../helpers';
import Title from '../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

// August 6th: refactored for responsiveness
class Tournaments extends React.Component {
    state = {}
    componentWillMount() {
        const { tournamentsActions, upcoming } = this.props;
        if (upcoming) {
            this.setState({ upcoming: _.chain(upcoming).groupBy('YearGroup').values().value() });
        }
        tournamentsActions.fetchUpcomingAll();
    }
    componentWillReceiveProps = nextProps => {
        const { upcoming } = nextProps;
        this.setState({ upcoming: _.chain(upcoming).groupBy('YearGroup').values().value() });        
    }
    componentDidMount() {
        preload(this.props);
    }
    render() {
        const { upcoming } = this.state;
        return <Layout nbs="tournaments" title="TOURNAMENTS" bi="/images/backgrounds/3balls.jpg">
            <section>
                <div id="tournaments">
                    <div className="w3-container w3-content margin-bottom-double">
                        <div style={{ height: 20 }} />
                        {upcoming && <Animated animationIn="fadeInLeft" animationInDelay={1000} className="d-flex flex-row-reverse"><Link to="/tournaments/past" className="white">PAST TOURNAMENTS</Link></Animated>}
                        {upcoming && upcoming.map((yearArray, j) => <section key={j}>
                            <Title text={`${moment(yearArray[0].DateStart).format('YYYY')} Tour Schedule`} className="white margin-top" />
                            {_.chain(yearArray).groupBy('Grouping').values().value().map((group, i) => <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} key={i} >
                                <h3 className="white margin-top-double hind">{moment(_.first(group).DateStart).format('MMMM')}</h3>
                                <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                    {_.orderBy(group, 'DateStart').map((t, j) => (
                                        <Animated key={t.id} animationIn="fadeInLeft" component="li" className="w3-card margin-top"
                                            style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                            <Tournament tournament={t} />
                                        </Animated>))}
                                </ul>
                            </ScrollAnimation>)}
                        </section>)}
                    </div>
                </div>
            </section>
        </Layout>
    }
}

export default Tournaments;



// WEBPACK FOOTER //
// ./src/components/tournaments/index.js